import { render, staticRenderFns } from "./indicator_summary.vue?vue&type=template&id=323cafc8&scoped=true&"
import script from "./indicator_summary.vue?vue&type=script&lang=js&"
export * from "./indicator_summary.vue?vue&type=script&lang=js&"
import style0 from "./indicator_summary.vue?vue&type=style&index=0&id=323cafc8&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323cafc8",
  null
  
)

export default component.exports